var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',{attrs:{"percentage":_vm.percentage,"status":_vm.status,"format":_vm.format,"stroke-width":_vm.height,"text-inside":_vm.inset,"color":_vm.color,"type":_vm.type,"width":_vm.width,"show-text":_vm.text,"stroke-linecap":_vm.bothShape}})
}
var staticRenderFns = []

export { render, staticRenderFns }